









































































import {cloneDeep} from 'lodash';
import {Component, Vue} from 'vue-property-decorator';
import TableRoute from '@c/tables/TableRoute.vue';
import Loading from '@c/controls/Loading.vue';
import {Can} from '@casl/vue';
import {OilNodeTableHeader} from './interfaces';
import oilModule from '@/store/modules/entities/oilModule';
import nodeModule from '@/store/modules/entities/nodeModule';
import {NodeData} from '@/system/nodes/interfaces';

@Component({
  components: {
    TableRoute,
    Loading,
    Can,
  },
})
export default class OilNodeList extends Vue {
  loadingTree = false;
  errorTree = false;

  headers: OilNodeTableHeader[] = [
    {
      text: 'Название',
      value: 'name',
      sortable: true,
    },
    {
      text: 'Описание',
      value: 'description',
      sortable: true,
    },
    {
      text: 'Узел',
      value: 'nodeId',
      sortable: true,
    },
  ];

  get apiStore() {
    return oilModule;
  }

  nodeItems: NodeData[] = [];

  getPathByNodeId(id: number): NodeData[] {
    const stack = [...this.nodeItems];
    const prev: Record<string, NodeData> = {};
    while (stack.length) {
      const x = stack.pop();
      if (x && x.id == id) {
        const path: NodeData[] = [];
        let node = x;
        path.push(node);
        while (prev[node.id ? node.id : 0]) {
          node = prev[node.id ? node.id : 0];
          path.push(node);
        }
        path.reverse();
        return path;
      }
      if (x && x.children)
        x.children.forEach(c => {
          if (c.id) {
            prev[c.id] = x;
            stack.push(c);
          }
        });
    }
    return [];
  }

  checkCorrectLevelNode = (parentType: number, node: NodeData) => node.type < parentType;

  checkChildren(item: NodeData) {
    if (item.children && item.children.length) {
      item.children.forEach(node => {
        if (item.children && item.children.length) {
          if (this.checkCorrectLevelNode(item.type, node)) {
            node.leveTypeError = true;
          }
          node.parent = {name: item.name, type: item.type};
          this.checkChildren(node);
        }
        return;
      });
    }
  }

  // Загрузка дерева
  async mounted() {
    await nodeModule.fetchAll();
    try {
      this.loadingTree = true;
      const temp = cloneDeep(nodeModule.all);
      temp.forEach(item => {
        this.checkChildren(item);
      });
      this.nodeItems = temp;
    } catch {
      this.errorTree = true;
    } finally {
      this.loadingTree = false;
    }
  }

  formatNodeName(id: number) {
    const arr = this.getPathByNodeId(id);
    return arr; //.map((n) => `<a href="/nodes/${n.id}">${n.name}</a>`).join(' > ');
  }

  onClickRow(item: any) {
    this.showAnalysis(item);
  }

  showAnalysis(item: any) {
    this.$router.push({
      name: 'OilReport',
      params: {oid: `${item.id}`},
    });
  }

  editOilNode(item: any) {
    this.$router.push({
      name: 'EditOilNode',
      params: {id: `${item.id}`},
    });
  }

  adminOilNode(item: any) {
    this.$router.push({
      name: 'AdminOilNode',
      params: {id: `${item.id}`},
    });
  }
}
